function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-transfer_svg__cls-1{stroke:#000;stroke-miterlimit:10;stroke-width:.75px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "icon-transfer_svg__cls-1",
  d: "M113.2 50.79l-13.6 13.6c-.82.88-2.2.92-3.08.1-.03-.03-.07-.06-.1-.1a2.18 2.18 0 01-.1-3.08c.03-.03.06-.07.1-.1l9.7-9.75H29.99c-1.25 0-2.27-1.02-2.27-2.27s1.02-2.27 2.27-2.27h76.14l-9.7-9.75c-.88-.88-.88-2.3 0-3.17.88-.88 2.3-.88 3.17 0l13.6 13.6c.23.19.4.44.5.73.23.55.23 1.17 0 1.72-.1.28-.27.53-.5.73zM102.55 81.04H26.41l9.7-9.75c.88-.88.88-2.3 0-3.17s-2.3-.88-3.17 0l-13.6 13.6c-.23.19-.4.44-.5.73a2.23 2.23 0 000 1.72c.1.28.27.53.5.73l13.6 13.6c.82.88 2.2.92 3.08.1.03-.03.07-.06.1-.1.88-.82.92-2.2.1-3.08-.03-.03-.06-.07-.1-.1l-9.7-9.75h76.13c1.25 0 2.27-1.02 2.27-2.27s-1.02-2.27-2.27-2.27z"
});

function SvgIconTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-transfer_svg__Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full"
  }, props), _ref, _ref2);
}

export default SvgIconTransfer;